import classNames from 'classnames';
import React from 'react';
import type { ElementProps } from '../../element/Element';
import { Elevation } from '../../elevation/Elevation';
import type { TimelineItemPositioningProps } from '../Timeline.types';
import { timelineItemPositioning } from '../Timeline.utils';
import styles from './Timeline.Event.module.scss';

export interface Props extends ElementProps {}

/**
 * "Calendar Event" component for the Timeline
 * @see Timeline.tsx where this is re-exported
 */
const TimelineLaneEventContainer = (props: Props & TimelineItemPositioningProps) => {
  const { offsetPx, sizePx, orientation, style, ...rest } = props;
  const dynamicStyles = timelineItemPositioning(props);

  return (
    <Elevation
      depth="low"
      context="inline"
      {...rest}
      style={{ ...dynamicStyles, ...style }}
      className={classNames(styles.eventContainer, props.className)}
    />
  );
};
TimelineLaneEventContainer.displayName = 'Timeline.Event';

/**
 * Wraps the Event on the Timeline
 */
export const TimelineEvent = Object.assign(TimelineLaneEventContainer, {});

TimelineEvent.displayName = 'Timeline.Event';
